export default "__VITE_ASSET__1db27543__"